module.exports = __webpack_public_path__ + "img/11.80c13f86.jpg";